import { render, staticRenderFns } from "./MandateTransactionsDetailsBulk.vue?vue&type=template&id=5f7d75b3&scoped=true&"
import script from "./MandateTransactionsDetailsBulk.vue?vue&type=script&lang=js&"
export * from "./MandateTransactionsDetailsBulk.vue?vue&type=script&lang=js&"
import style0 from "./MandateTransactionsDetailsBulk.vue?vue&type=style&index=0&id=5f7d75b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7d75b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f7d75b3')) {
      api.createRecord('5f7d75b3', component.options)
    } else {
      api.reload('5f7d75b3', component.options)
    }
    module.hot.accept("./MandateTransactionsDetailsBulk.vue?vue&type=template&id=5f7d75b3&scoped=true&", function () {
      api.rerender('5f7d75b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandateTransactionsDetailsBulk.vue"
export default component.exports